export default {"src":"/_next/static/media/Lung-Cancer.4a8e80e1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};